"use client";

import { Text } from "@chakra-ui/react";
import { ErrorBoundary } from "@sentry/nextjs";
import { type ReactNode, useEffect, useState } from "react";

import { content } from "@/app/utils/CONSTS";

export function ErrorBoundaryWithFeedback({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <>{children}</>;
  }

  return (
    <ErrorBoundary
      fallback={
        <Text p="3" px="5" color="orange.500">
          {`An error occurred, please try to refresh your page 
          or send a text message to us by using the "${content.sentry.feedbackWidgetTitle}" button.`}
        </Text>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
